export class HeaderMenu {
	constructor(element) {
		if (!element) return;
		this.element = element;
		this.back = this.element.querySelector('.header-menu__back');

		this.init();
	}

	backClickHandler = () => {
		const activeScreen1 = this.element.querySelector('.header-menu__screen--active.header-menu__screen--1');
		const activeScreen2 = this.element.querySelector('.header-menu__screen--active.header-menu__screen--2');
		if (activeScreen2) activeScreen2.classList.remove('header-menu__screen--active');
		else if (activeScreen1) activeScreen1.classList.remove('header-menu__screen--active');
	};

	openerClickHandler = (target) => {
		const screen = target.parentNode.querySelector('.header-menu__screen');
		if (screen) screen.classList.add('header-menu__screen--active');
	};

	clickHandler = (event) => {
		const { target } = event;
		const opener = target.closest('.header-menu__opener');
		const parentLink = target.closest(':is(.header-menu__category--parent, .header-menu__list-item--parent) > a');

		if (opener) this.openerClickHandler(opener);
		if (parentLink) {
			event.preventDefault();
			this.openerClickHandler(parentLink);
		}
		if (target === this.back) this.backClickHandler();
	};

	init = () => {
		this.element.addEventListener('click', this.clickHandler);
	};
}
